import React from "react";
import { Typography, IconButton, Chip } from "@material-ui/core";
import { Close, CheckCircle, Error, Warning } from "@material-ui/icons";

const styles = {
  overlay: {
    position: "absolute",
    bottom: "16px",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 100,
    maxWidth: "560px",
    width: "90%",
  },
  panel: (isValid) => ({
    background: "#fff",
    borderRadius: "12px",
    boxShadow: "0 8px 32px rgba(0,0,0,0.15), 0 2px 8px rgba(0,0,0,0.08)",
    border: `2px solid ${isValid ? "#43a047" : "#e53935"}`,
    overflow: "hidden",
  }),
  header: (isValid) => ({
    padding: "12px 16px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    background: isValid ? "#e8f5e9" : "#ffebee",
    borderBottom: `1px solid ${isValid ? "#c8e6c9" : "#ffcdd2"}`,
  }),
  body: {
    padding: "12px 16px",
    maxHeight: "200px",
    overflowY: "auto",
  },
  item: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    padding: "6px 0",
    fontSize: "13px",
    lineHeight: "1.4",
    color: "#333",
  },
  successBody: {
    padding: "16px",
    textAlign: "center",
    color: "#2e7d32",
    fontSize: "14px",
  },
};

export default function ValidationPanel({ validation, onClose, onNodeClick, resources = {} }) {
  if (!validation) return null;

  const { isValid, errors, warnings } = validation;
  const totalIssues = errors.length + warnings.length;

  return (
    <div style={styles.overlay}>
      <div id="diagnostic-flow-validation-panel" style={styles.panel(isValid)}>
        <div style={styles.header(isValid)}>
          {isValid ? (
            <CheckCircle style={{ color: "#43a047", fontSize: "22px" }} />
          ) : (
            <Error style={{ color: "#e53935", fontSize: "22px" }} />
          )}
          <Typography
            variant="subtitle2"
            style={{ fontWeight: 700, flex: 1, fontSize: "14px" }}
          >
            {isValid
              ? resources["FlowIsValid"]
              : resources["IssuesFound"].replace("#Count#", totalIssues)}
          </Typography>
          {!isValid && (
            <>
              <Chip
                size="small"
                label={resources["ErrorsCount"].replace("#Count#", errors.length)}
                style={{
                  background: errors.length > 0 ? "#e53935" : "#e0e0e0",
                  color: errors.length > 0 ? "#fff" : "#999",
                  fontWeight: 600,
                  fontSize: "11px",
                  height: "22px",
                }}
              />
              {warnings.length > 0 && (
                <Chip
                  size="small"
                  label={resources["WarningsCount"].replace("#Count#", warnings.length)}
                  style={{
                    background: "#ff9800",
                    color: "#fff",
                    fontWeight: 600,
                    fontSize: "11px",
                    height: "22px",
                  }}
                />
              )}
            </>
          )}
          <IconButton id="close-diagnostic-flow-validation" size="small" onClick={onClose}>
            <Close fontSize="small" />
          </IconButton>
        </div>

        {isValid ? (
          <div style={styles.successBody}>
            {resources["FlowValidDescription"]}
          </div>
        ) : (
          <div style={styles.body}>
            {errors.map((err, i) => (
              <div
                key={`e-${i}`}
                style={{
                  ...styles.item,
                  cursor: err.nodeId ? "pointer" : "default",
                }}
                onClick={() => err.nodeId && onNodeClick && onNodeClick(err.nodeId)}
              >
                <Error
                  style={{
                    color: "#e53935",
                    fontSize: "18px",
                    marginTop: "1px",
                    flexShrink: 0,
                  }}
                />
                <span>
                  {err.message}
                  {err.nodeId && (
                    <span
                      style={{
                        color: "#1a73e8",
                        marginLeft: "6px",
                        fontSize: "11px",
                        fontWeight: 600,
                      }}
                    >
                      {resources["ClickToFocus"]}
                    </span>
                  )}
                </span>
              </div>
            ))}
            {warnings.map((warn, i) => (
              <div
                key={`w-${i}`}
                style={{
                  ...styles.item,
                  cursor: warn.nodeId ? "pointer" : "default",
                }}
                onClick={() =>
                  warn.nodeId && onNodeClick && onNodeClick(warn.nodeId)
                }
              >
                <Warning
                  style={{
                    color: "#ff9800",
                    fontSize: "18px",
                    marginTop: "1px",
                    flexShrink: 0,
                  }}
                />
                <span>{warn.message}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
